import { render, staticRenderFns } from "./CreateListButton.vue?vue&type=template&id=06abb803&scoped=true&"
import script from "./CreateListButton.vue?vue&type=script&lang=js&"
export * from "./CreateListButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateListButton.vue?vue&type=style&index=0&id=06abb803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06abb803",
  null
  
)

export default component.exports